export default __webpack_public_path__ + "images/62820881cb99697beb8f79466e6ef0eb-baseball.webp";